module.exports = __webpack_public_path__ + "img/msaw.6816ed0a.svg";